<template>
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
    @submit.prevent="updateDefinition"
  >
    <v-card>
      <v-card-title primary-title>
        Uppdatera definition
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row>
            <v-col>
              <v-text-field
                filled
                v-model.number="model.train_number_from"
                type="number"
                label="Tågnummer från"
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                filled
                v-model.number="model.train_number_to"
                type="number"
                label="Tågnummer till"
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-select
                v-model="model.train_group"
                :items="trainGroups"
                filled
                label="Tåg grupp"
                :rules="[rules.required]"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-textarea
                filled
                label="Definition"
                v-model="model.definition_text"
                placeholder="Definitions text"
                :rules="[rules.required]"
              />
            </v-col>
          </v-row>
          <v-row v-if="errors.length">
            <v-col>
              <p class="error--text" v-for="(error, $i) in errors" :key="$i">
                {{ error }}
              </p>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn tile text @click="close" :disabled="pendingUpdate">
          Avbryt
        </v-btn>
        <v-btn tile color="primary" text type="submit" :loading="pendingUpdate">
          Uppdatera
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import rules from '@/common/validationRules.js'
import gql from 'graphql-tag'

export default {
  name: 'DefinitionUpdate',

  data: () => ({
    pendingUpdate: false,
    rules,
    valid: true,
    trainGroups: ['P', 'R'],
    model: {
      train_number_from: 1,
      train_number_to: 2,
      train_group: 'P',
      definition_text: ''
    }
  }),

  props: {
    definition: Object
  },

  created() {
    this.model.train_number_from = this.definition.train_number_from
    this.model.train_number_to = this.definition.train_number_to
    this.model.train_group = this.definition.train_group
    this.model.definition_text = this.definition.definition_text
  },

  computed: {
    ruleTrainNumberFrom() {
      return this.model.train_number_from > this.model.train_number_to
        ? 'Tågnummer från måste vara lägre eller samma än tågnummer till'
        : false
    },

    ruleTrainNumberTo() {
      return this.model.train_number_to < this.model.train_number_from
        ? 'Tågnummer till måste vara högre eller samma än tågnummer från'
        : false
    },

    errors() {
      return [this.ruleTrainNumberFrom, this.ruleTrainNumberTo].filter(Boolean)
    }
  },

  methods: {
    close() {
      this.$emit('close')
    },

    async updateDefinition() {
      const isValid = await this.$refs.form.validate()

      if (!isValid || this.errors.length) return

      this.pendingUpdate = true

      await this.$apollo.mutate({
        mutation: gql`
          mutation updateDefinition(
            $id: Int!
            $payload: UpdateDefinitionInput!
          ) {
            updateDefinition(id: $id, payload: $payload)
          }
        `,

        variables: {
          payload: {
            ...this.model
          },
          id: parseInt(this.definition.id, 10)
        }
      })

      this.pendingUpdate = false
      this.$emit('confirm')
    }
  }
}
</script>
